import React, {useEffect} from 'react';
import {ActionModal, ErrorModal, FormInput, useErrorHandler} from '../../../../shared';
import {useEditProjectDocumentForm} from '../../model';
import {ProjectDocumentModel} from '../../../../entities';

interface EditProjectDocumentModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  documentId: string;
  document: ProjectDocumentModel | null;
}

export const EditProjectDocumentModal = ({open, setOpen, documentId, document}: EditProjectDocumentModalProps) => {
  const {values, errors, touched, handleChange, handleBlur, isLoading, submitError, resetForm, submitForm} =
    useEditProjectDocumentForm({documentId, document, setOpen});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Документ',
    title: 'Ошибка при редактировании документа',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  // Сбрасываем форму при открытии модального окна
  useEffect(() => {
    if (open) {
      resetForm();
    }
  }, [open, resetForm]);

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Редактировать документ'}
        textButtonApply={'Сохранить'}
        textButtonCancel={'Отменить'}>
        <FormInput
          label="Название"
          placeholder="Название документа"
          name="title"
          value={values.title}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          error={touched.title && errors.title}
        />
        <FormInput
          label="Приоритет"
          placeholder="1"
          name="priority"
          type="number"
          value={values.priority.toString()}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          error={touched.priority && errors.priority}
        />
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};

